<template>

  <div>

    <b-container>

      <div v-if="!$store.getters.isUser" class="mt-4">
          <b-row class="mb-0" align-v="stretch">
            <b-col>
              <b-card>
                <h1 class="display-4">{{ dashboardInfos.newProjectsNb }}</h1>
                <h4 class="mt-2">{{$t('projects.New')}}</h4>
                <h6 class="mt-2 font-weight-bold">{{$t('projects.toEvaluate')}}</h6>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="text-left">
                <h1 class="display-4">{{ dashboardInfos.infosNeededProjectsNb }}</h1>
                <h4 class="mt-2">{{$t('projects.Uncertified')}}</h4>
                <h6 class="mt-2 font-weight-bold">{{$t('projects.InfosNeeded')}}</h6>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="text-left">
                <h1 class="display-4">{{ dashboardInfos.certifiedActionsNeededProjectsNb }}</h1>
                <h4 class="mt-2">{{$t('projects.Certified')}}</h4>
                <h6 class="mt-2 font-weight-bold">{{$t('projects.ActionsNeeded')}}</h6>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="text-left">
                <h1 class="display-4">{{ dashboardInfos.certifiedPublishedProjectsNb }}</h1>
                <h4 class="mt-2">{{$t('projects.CertifiedPublished')}}</h4>
                <h6 class="mt-2 font-weight-bold">{{$t('projects.Agenda')}}</h6>
              </b-card>
            </b-col>
          </b-row>
      </div>

      <div class="mt-4 mb-4 d-flex align-items-center justify-content-between">
        <div class="burger-spacing">
          <h1 class="page-title">{{$t('Projects')}}</h1>
          <h2 class="page-subtitle">{{$t('Total')}} : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
          {{$t('Add')}} {{$t('a')}} {{$t('project')}}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b122-table
          ref="B122TableProject"
          identifier="B122TableProject"
          init-b122-table-url="/project/initB122Table"
          get-b122-table-results-url="/project/getB122TableResults"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('project.emptyTitle').toString()"
          :empty-text="$t('project.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">

          <template #cell(name)="row">
            <div class="d-inline-block text-truncate" style="max-width: 200px;" v-b-tooltip="row.item.name">
              {{row.item.name}}
            </div>
          </template>

          <template #cell(projectStatus)="row">
            <div :class="'bold-text text-' + $t(row.item.projectStatus.text+'.variant') ">
              {{$t(row.item.projectStatus.text)}}
            </div>
          </template>

          <template #cell(creator)="row">
            <div v-if="$store.getters.isAdmin">
              <b-link :href="'#/user/show/' + row.item.creator.id">{{row.item.creator.tostring}}</b-link>
            </div>
            <div v-else>
              {{row.item.creator.tostring}}
            </div>
          </template>

          <template #cell(commissionComment)="row">
            <i class="ph-fill ph-chat-circle-text" size="20" v-b-tooltip="row.item.commissionComment"></i>
          </template>

        </b122-table>
      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <Item-delete-modal
      itemSingularName="project"
      :beginsWithVoyel="true"
      :selectedItem="ui.selectedProject"
      :selectedItemSpecialString="ui.selectedProject ? ui.selectedProject.tostring : null"
      controllerName="project"
      itemSingularNameUpp="Project"
      @didDeleteItem="didDeleteProject()">
    </Item-delete-modal>

  </div>

</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue"
import i18n from "../../i18n"
import api from "../../services/api";

export default {

  name: 'ProjectIndex',

  components: {
    ItemDeleteModal,
    B122Table,
  },

  data () {
    return {
      dashboardInfos: {
        newProjectsNb: 0,
        infosNeededProjectsNb: 0,
        certifiedActionsNeededProjectsNb: 0,
        certifiedPublishedProjectsNb: 0
      },
      totalCount: 0,
      allowCreate: this.$store.getters.isUser,
      allowDelete: false,
      allowEdit: false,

      ui: {
        selectedProject: null
      }

    }
  },

  computed: {

    tableFields() {
      return this.$store.getters.isUser? this.tableUserFields: this.tableCommissionFields
    },

    tableUserFields () {
      return [
        {
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('project.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$i18n.t('Commission'),
          key: 'commission',
          sortable: true,
          formatter: function(value) {
            return value? value.tostring: null
          }
        },
        {
          label: this.$i18n.t('ProjectTypes'),
          key: 'projectTypes',
          sortable: false,
          formatter: function(value) {
            return value? value.map(projectType => projectType.tostring).join(", "): null
          }
        },
        {
          label: this.$i18n.t('project.Date'),
          key: 'date',
          sortable: false,
          formatter: function (value) {
            return value ? new Date(value).toLocaleDateString('fr-FR') : null
          }
        },
        {
          label: this.$i18n.t('ProjectStatus'),
          key: 'projectStatus',
          sortable: true,
          formatter: function(value) {
            return value? i18n.t(value.text): null
          }
        }
      ]
    },

    tableCommissionFields () {
      return [

        {
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('project.ID'),
          key: 'id',
          sortable: true
        },
        {
          label: this.$i18n.t('project.SubmissionDate'),
          key: 'submissionDate',
          sortable: true,
          formatter: function (value) {
            return value ? new Date(value).toLocaleDateString('fr-FR') : null
          }
        },
        {
          label: this.$i18n.t('project.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$i18n.t('ProjectStatus'),
          key: 'projectStatus',
          sortable: true,
          formatter: function(value) {
            return value? i18n.t(value.text): null
          }
        },
        {
          label: this.$i18n.t('Commission'),
          key: 'commission',
          sortable: true,
          formatter: function(value) {
            return value? value.tostring: null
          }
        },
        {
          label: this.$i18n.t('ProjectTypes'),
          key: 'projectTypes',
          sortable: false,
          formatter: function(value) {
            return value? value.map(projectType => projectType.tostring).join(", "): null
          }
        },
        {
          label: this.$i18n.t('project.Creator'),
          key: 'creator',
          sortable: false,
          formatter: function(value) {
            return value? value.tostring: null
          }
        },
        {
          label: this.$i18n.t('projectPlace.City'),
          key: 'projectPlace',
          sortable: false,
          formatter: function(value) {
            return value? value.city: null
          }
        },
        {
          label: '',
          key: 'commissionComment',
          sortable: false
        }
      ]
    }

  },

  mounted() {
    this.fetchData();
  },

  methods: {

    fetchData() {
      if (!this.$store.getters.isUser) {
        this.fetchDashboardInfos()
      }
    },

    fetchDashboardInfos () {
      api
        .get(`/dashboard/getDashboardInfos`)
        .then(response => {
          this.dashboardInfos = response.data

        })
    },

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'ProjectCreate'
      })
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'ProjectShow',
        params: {
          projectId: row.item.id
        }
      })
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'ProjectEdit',
        params: {
          projectId: row.item.id
        }
      })
    },

    clickOnDeleteBtn (row) {
      this.ui.selectedProject = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteProject () {
      this.ui.selectedProject = null
      this.$refs.B122TableProject.refreshTable()
    }
  }
}
</script>

<style scoped>

h1.display-4 {
  font-family: "SourceSerif4-Bold", "Arial", sans-serif;
}

h4 {
  font-family: "SourceSerif4-Regular", "Arial", sans-serif;
}

h6 {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

.col .card{
  height: 100%;
}
.col .card .card-body{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/project/ProjectIndex.vue